module.exports = __webpack_public_path__ + "static/beauty-top-banner-section-code-b28417d60080466f8b1ea0c50317f426.png";